(function () {
  'use strict';

  function initCustomerCare() {
    document.querySelectorAll('[data-header-customer-care]').forEach(function (component) {
      var trigger = component.querySelector('[data-cc-trigger]');
      var panel = component.querySelector('[data-cc-panel]');

      if (!trigger || !panel) return;

      // Avoid double-binding
      if (trigger.dataset.ccInit) return;
      trigger.dataset.ccInit = 'true';

      function open() {
        panel.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        var firstLink = panel.querySelector('a');
        if (firstLink) firstLink.focus();
      }

      function close(returnFocus) {
        panel.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        if (returnFocus) trigger.focus();
      }

      trigger.addEventListener('click', function () {
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          close(false);
        } else {
          open();
        }
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !panel.hidden) {
          close(true);
        }
      });

      document.addEventListener('pointerdown', function (e) {
        if (!panel.hidden && !component.contains(e.target)) {
          close(false);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomerCare);
  } else {
    initCustomerCare();
  }

  document.addEventListener('shopify:section:load', initCustomerCare);
})();